import { render, staticRenderFns } from "./address-identification.vue?vue&type=template&id=0760b3d5&scoped=true&"
import script from "./address-identification.vue?vue&type=script&lang=js&"
export * from "./address-identification.vue?vue&type=script&lang=js&"
import style0 from "./address-identification.vue?vue&type=style&index=0&id=0760b3d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760b3d5",
  null
  
)

export default component.exports